// extracted by mini-css-extract-plugin
module.exports = {"guidesContent":"GuidesCarousel_guidesContent__nOsOi","header":"GuidesCarousel_header__NRWaQ","title":"GuidesCarousel_title__Wpcp8","titleText":"GuidesCarousel_titleText__xTXKQ"};